import PropTypes from "prop-types";
import CoinGauge from "./CoinGauge";
import { normalizeSymbols } from "../lib/runtimeConfig";

export default function ScalpPanel({ engineCoins = [], prices = {}, compact = false, updatedAt = null, gauges = {}, className = "" }) {
    const coins = normalizeSymbols(engineCoins || []);
    return (
        <div className={`bg-gray-900 rounded-xl p-5 sm:p-6 shadow-md h-full ${className}`}>
            <h2 className="text-lg font-semibold mb-4 flex items-center gap-2">⚡ Scalping Strategy</h2>
            {coins.length === 0 ? (
                <div className="text-sm text-gray-400">No scalping coins active.</div>
            ) : (
                <div className={`panel-grid${compact ? ' compact' : ''}`}>
                    {coins.map((sym) => {
                        const gauge = gauges?.["scalp:" + sym] || { symbol: sym, engine: "scalp", price: prices[sym], updatedAt };
                        const gaugeProps = { ...gauge };
                        delete gaugeProps.key;
                        return <CoinGauge key={"scalp:" + sym} {...gaugeProps} symbol={gauge.symbol || sym} price={gauge.price ?? prices[sym]} updatedAt={gauge.updatedAt ?? updatedAt} />;
                    })}
                </div>
            )}
        </div>
    );
}

ScalpPanel.propTypes = {
    engineCoins: PropTypes.array, prices: PropTypes.object, compact: PropTypes.bool,
    updatedAt: PropTypes.oneOfType([PropTypes.number, PropTypes.string]), gauges: PropTypes.object, className: PropTypes.string,
};
